const NAME = "ENTRY_EXIT_TYPES_SETTINGS";

export default NAME;
